<template>
    <v-layout>
        <v-dialog v-model="monday.item.dialog" persistent scrollable width="70%">
            <v-card :loading="monday.item.loading">
                <template slot="progress">
                    <v-progress-linear color="amber darken-2" indeterminate></v-progress-linear>
                </template>
                <v-toolbar :color="(monday.item.hasDownloadError) ? 'error' : 'primary'">
                    <v-toolbar-title style="color: white"><v-icon>$vuetify.icons.mondayicon</v-icon> {{$t('json.mondayfiles')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn v-show="!monday.item.hasDownloadError" dark :disabled="disabled" icon @click="refresh"><v-icon>mdi-cloud-refresh</v-icon></v-btn>
                </v-toolbar>
                <v-card-text v-show="!monday.item.hasDownloadError" style="max-height: 500px;">
                    <v-list two-line :disabled="disabled">
                        <v-list-item-group v-model="selectedIndex" multiple active-class="blue--text">
                            <template v-for="(asset, index) in assets">
                                <v-list-item :key="asset.id" v-show="!asset.downloaded">
                                    <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="asset.name"></v-list-item-title>
                                        <v-list-item-subtitle v-text="$t('json.mondayfiles_by') + ': ' + asset.uploaded_by.name + ' '  + $t('json.mondayfiles_total') + ': ' + asset.file_size + 'KB'"></v-list-item-subtitle>
                                        <v-list-item-subtitle v-text="$t('json.mondayfiles_date') + ': '+ new Date(asset.created_at).toLocaleString('en-US')"></v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon v-if="!active" color="grey lighten-1">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else color="blue darken-3">mdi-check-circle</v-icon>
                                    </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider v-if="index < assets.length - 1" :key="index"></v-divider>
                            </template>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-card-text v-show="monday.item.hasDownloadError" style="max-height: 500px;">
                    <v-list two-line :disabled="disabled">
                        <v-list-item-group v-model="selectedIndex" multiple active-class="blue--text">
                            <template v-for="(asset, index) in errorAsstes">
                                <v-list-item :key="asset.id">
                                    <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="asset.name"></v-list-item-title>
                                        <v-list-item-subtitle v-text="$t('json.mondayfiles_by') + ': ' + asset.uploaded_by.name + ' '  + $t('json.mondayfiles_total') + ': ' + asset.file_size + 'KB'"></v-list-item-subtitle>
                                        <v-list-item-subtitle v-text="$t('json.mondayfiles_date') + ': '+ new Date(asset.created_at).toLocaleString('en-US')"></v-list-item-subtitle>
                                        <v-list-item-subtitle v-text="asset.message"></v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon v-if="!active" color="grey lighten-1">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else color="blue darken-3">mdi-check-circle</v-icon>
                                    </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider v-if="index < errorAsstes.length - 1" :key="index"></v-divider>
                            </template>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions v-show="!monday.item.hasDownloadError">
                    <v-btn text @click="monday.item.dialog = false">{{$t('json.mondayfiles_close')}}</v-btn>
                    <v-btn :disabled="disabled" color="primary" text @click="selectAll">{{ selectedIndex.length === assets.length ? $t('json.mondayfiles_unselectall') : $t('json.mondayfiles_selectall') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="selectedIndex.length === 0 || disabled" color="primary" text @click="download">{{$t('json.mondayfiles_down')}}</v-btn>
                </v-card-actions>
                <v-card-actions v-show="monday.item.hasDownloadError">
                    <v-btn text color="error" @click="cancelDownload">{{$t('json.mondayfiles_cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="continueDownload">{{$t('json.mondayfiles_continue')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import Models from '../Models'
export default {
  name: 'MondayFiles',
  props: ['monday', 'ws', 'disabled', 'mondayContext'],
  data () {
    return {
      selectedIndex: []
    }
  },
  computed: {
    errorAsstes () {
      return this.monday.item.errorAsstes.filter(asset => asset.downloaded === false)
    },
    assets () {
      return this.monday.item.assets.filter(asset => asset.downloaded === false)
    }
  },
  methods: {
    async continueDownload () {
      const action = Models.Action
      action.TYPE = Models.ActionType.MONDAY_FILES_DOWNLOAD_CONFIRM
      action.Data = '0'
      action.MondayAssets = this.monday.item.assets
      this.ws._send(action)
      this.monday.item.assets = []
      this.monday.item.errorAsstes = []
      this.monday.item.hasDownloadError = false
      this.monday.item.loading = false
      this.monday.item.dialog = false
    },
    async cancelDownload () {
      const action = Models.Action
      action.TYPE = Models.ActionType.MONDAY_FILES_DOWNLOAD_CONFIRM
      action.Data = '1'
      this.ws._send(action)
      this.monday.item.errorAsstes = []
      this.monday.item.hasDownloadError = false
      this.monday.item.loading = false
    },
    async refresh () {
      this.monday.item.loading = true
      await this.getMondayItemAssets(this.monday.item.id)
      this.monday.item.loading = false
    },
    async download () {
      this.monday.item.loading = true
      this.$emit('download', this.monday.item.assets)
    },
    unselectAll () {
      this.selectedIndex = []
    },
    async selectAll () {
      if (this.selectedIndex.length === this.monday.item.assets.length) {
        this.selectedIndex = []
      } else {
        const indexes = Array.from(Array(this.monday.item.assets.length).keys())
        /* this.monday.item.assets.forEach((a, index) => {
          indexes.push(index)
        }) */
        this.selectedIndex = []
        this.selectedIndex.push(...indexes)
      }
    },
    async getMondayItemAssets (ids) {
      console.log('getMondayItemAssets()', ids)
      this.monday.item.assets = []
      this.monday.item.errorAsstes = []
      const itemData = await this.monday.sdk.api(`query { items(ids: ${ids}) {
                                                  assets {
                                                    id
                                                    name
                                                    public_url
                                                    file_extension
                                                    file_size
                                                    url
                                                    created_at
                                                    uploaded_by {
                                                      id
                                                      name
                                                    }
                                                  }
                                                  updates {
                                                    assets {
                                                      id
                                                      name
                                                      public_url
                                                      file_extension
                                                      file_size
                                                      url
                                                      created_at
                                                      uploaded_by {
                                                        id
                                                        name
                                                      }
                                                    }
                                                  }
                                                }
                                              }`)
      console.log('Monday Item Assets', itemData)
      itemData.data.items.forEach((item) => {
        item.assets.forEach((a) => {
          a.message = ''
          a.download = false
        })
        this.monday.item.assets.push(...item.assets)
        item.updates.forEach((update) => {
          update.assets.forEach((a) => {
            a.message = ''
            a.downloaded = false
          })
          this.monday.item.assets.push(...update.assets)
        })
      })
    }
  },
  watch: {
    'monday.item.assets': function (newVal) {
      this.selectedIndex = []
      // this.selectedIndex.push(0)
    },
    'monday.item.id': function (newVal) {
      if (newVal !== undefined && newVal !== null && newVal !== '') this.getMondayItemAssets(newVal)
    },
    selectedIndex: function (newVal) {
      this.monday.item.assets.forEach((asset) => {
        // console.log('ASSET', asset)
        asset.selected = false
      })
      newVal.forEach(i => {
        const asst = this.monday.item.assets[i]
        if (asst !== undefined) {
          // console.log('ASSET NEWVAL', i, asst)
          asst.selected = true
        }
      })
    }
  }
}
</script>
